'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = inherits;
var _Object = Object;

function inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  }

  subClass.prototype = _Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) {
    _Object.setPrototypeOf ? _Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
}


/*****************
 ** WEBPACK FOOTER
 ** ../~/emoji-mart/dist/polyfills/inherits.js
 ** module id = 1608
 ** module chunks = 3
 **/